import React from 'react';
import styles from './DescribeSection.module.css';
import image from './images/assets2.png';
import {
    OptimizedMotionH1,
    OptimizedMotionP,
} from '../../../shared/ui/optimized-motion/OptimizedMotion';

const DescribeSection: React.FC = () => {
    return (
        <div className={styles.container}>
            <img src={image} alt="describe" className={styles.image} />
            <div>
                <OptimizedMotionH1 className={styles.title} type="slide-down" delay={0.2}>
                    Instant Traceability
                </OptimizedMotionH1>
                <OptimizedMotionP className={styles.description} type="slide-down" delay={0.4}>
                    Need to know why a headline changed or who removed a disclaimer? Click "History"
                    to view side‑by‑side diffs, complete with approver notes and timestamps. Roll
                    back to any point with one click, or branch a new version for experimentation
                    without overwriting the original.
                </OptimizedMotionP>
            </div>
            <div className={styles.blur}></div>
        </div>
    );
};

export default DescribeSection;
